import React from 'react';
export function TrustBuilder() {
  return <div className="bg-stark-white border-y border-gray-100 py-6 overflow-hidden" data-id="element-154">
      <div className="max-w-7xl mx-auto px-6" data-id="element-155">
        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-midnight-navy/60 text-sm font-manrope font-semibold uppercase tracking-widest text-center" data-id="element-156">
          <span data-id="element-157">Built for restaurant operators who are tired of:</span>
          <span className="text-midnight-navy" data-id="element-158">Missing margins</span>
          <span className="text-accent-red" data-id="element-159">•</span>
          <span className="text-midnight-navy" data-id="element-160">Overspending</span>
          <span className="text-accent-red" data-id="element-161">•</span>
          <span className="text-midnight-navy" data-id="element-162">Delayed clarity</span>
          <span className="text-accent-red" data-id="element-163">•</span>
          <span className="text-midnight-navy" data-id="element-164">Manual inventory</span>
          <span className="text-accent-red" data-id="element-165">•</span>
          <span className="text-midnight-navy" data-id="element-166">Zero visibility</span>
        </div>
      </div>
    </div>;
}